const LoadMorePagination = ({
  hasMore,
  onLoadMore,
  children,
  loading,
  hideLoadmore,
  isBanking,
}) => (
  <div>
    {children}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      {hasMore && !hideLoadmore && (
        <button
          style={{
            backgroundColor: "transparent",
            border: "0px",
            textAlign: "center",
            margin: isBanking ? "10px auto" : "20px auto",
            display: "block",
            fontSize: "16px",
            cursor: "pointer",
            color: "#f18e52",
          }}
          onClick={onLoadMore}
          disabled={loading}
        >
          {loading ? "Loading..." : "Load More"}
        </button>
      )}
    </div>
  </div>
);

export default LoadMorePagination;
